import React from 'react';
import { motion } from 'framer-motion';

interface MobileCostViewProps {
  particlesRef: React.RefObject<HTMLDivElement>;
}

const MobileCostView: React.FC<MobileCostViewProps> = ({ particlesRef }) => {
  return (
    <div className="w-full max-w-screen-sm mx-auto px-0 relative">
      <div className="particles absolute top-0 left-0 w-full h-full pointer-events-none z-[-1]" ref={particlesRef}></div>
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="w-full px-0"
      >
        <img 
          src="/lovable-uploads/e7ee4157-d8e8-4bf7-aa26-075c774d881a.png" 
          alt="Cost Savings Breakdown" 
          className="w-full h-auto scale-125 sm:scale-100"
          loading="lazy"
          onError={(e) => {
            console.error('Failed to load cost savings image');
            // Fallback to placeholder if needed
          }}
        />
      </motion.div>
    </div>
  );
};

export default MobileCostView;
